/**
 * Elenco delle guide pubbliche — fonte di verità unica per la navigazione.
 *
 * Consumato da: AppHeader (menu), AppFooter (link site-wide), LandingView
 * (sezione guide), GuideHubView (elenco) e dalle singole guide per i
 * "Continua a leggere".
 *
 * Aggiungendo una guida qui va aggiunta anche in src/router/index.js e in
 * seo-routes.cjs, altrimenti compare nei menu ma non viene prerenderizzata.
 */
export const GUIDES = [
    {
        path: '/guide/velocizzare-videolezioni-mercatorum',
        title: 'Come velocizzare le videolezioni Mercatorum',
        navTitle: 'Velocizzare le lezioni Mercatorum',
        summary: 'Perché la riproduzione non si può accelerare e come far scorrere da sole le lezioni Mercatorum.',
        icon: 'mdi-fast-forward'
    },
    {
        path: '/guide/velocizzare-videolezioni-pegaso',
        title: 'Come velocizzare le videolezioni Pegaso',
        navTitle: 'Velocizzare le lezioni Pegaso',
        summary: 'Perché il monte ore non è comprimibile e cosa si può ridurre davvero su Pegaso.',
        icon: 'mdi-fast-forward'
    },
    {
        path: '/guide/autoplay-come-funziona',
        title: 'Autoplay UQM: come funziona e come si installa',
        navTitle: 'Autoplay: come funziona',
        summary: 'Installazione, browser supportati, costi e domande frequenti.',
        icon: 'mdi-help-circle-outline'
    }
]

/** Le altre guide rispetto a quella corrente, per i blocchi "Continua a leggere". */
export function otherGuides(currentPath) {
    return GUIDES.filter((g) => g.path !== currentPath)
}
